<template>
    <div class="checkbox-container">
        <div class="icheck-primary">
            <input type="checkbox" v-model="checked" @change="check($event)">
        </div>
        <label v-if="label" @click="setChecked(!checked)">{{ label }}</label>
    </div>
</template>
<script>
export default {
    name: "Checkbox",
    emits: ['update:initChecked'],
    props: {
        label: {
            type: String,
            default: null
        },
        initChecked: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            checked: this.initChecked
        }
    },
    methods: {
        check($event) {
            this.$emit('update', $event);
            this.$emit('update:initChecked', $event);
        },
        setChecked(checked) {
            this.checked = checked;
            this.$emit('update', checked);
            this.$emit('update:initChecked', checked);
        }
    },
    watch: {
        initChecked(newVal){
            this.setChecked(newVal);
        }
    }
}
</script>
<style>
    .checkbox-container{
        line-height: 1;
        align-items: center;
        display: flex;
    }
    .checkbox-container > div{
        margin-right: 5px;
        margin-top: 2px;
    }
    .checkbox-container input[type="checkbox"], .checkbox-container label{
        cursor: pointer;
    }
</style>
